import React from "react";

export const MicrosoftAuthCallback = () => (
  <div role="status" aria-live="polite">
    Completing Microsoft sign-in…
  </div>
);
